import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

export default function Home() {
  const images = [
    "/images/back1.jpeg",
    "/images/back2.jpeg",
    "/images/fort2.jpg",
    "/images/garden.jpg",
    "/images/gate.jpg",
  ];

  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [images.length]);

  /* ========= TABLE CSS ========= */
  const tableStyle = {
    width: "90%",
    margin: "30px auto",
    borderCollapse: "collapse",
    fontSize: "18px",
    boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
    borderRadius: "10px",
    overflow: "hidden",
  };

  const thStyle = {
    background: "linear-gradient(135deg, #4A148C, #6A1B9A)",
    color: "white",
    padding: "12px",
    fontSize: "20px",
  };

  const tdStyle = {
    padding: "12px",
    borderBottom: "1px solid #ddd",
    fontWeight: "600",
  };

  const rowStyle = { background: "#f7e9ff" };

  return (
    <div className="home-container">

      {/* HERO SLIDER */}
      <div
        className="hero-section"
        style={{
          marginTop: "50px",
          height: "550px",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundImage: `url(${images[current]})`,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          textShadow: "2px 2px 8px rgba(0,0,0,0.8)",
          transition: "background-image 1s ease-in-out",
          borderRadius: "10px",
          marginLeft: "20px",
          marginRight: "20px",
        }}
      >
        <h1 style={{ fontSize: "32px", fontWeight: "bold" }}>
          पंचायत समिती बल्लारपूर
        </h1>

        <p style={{ fontSize: "18px", marginTop: "5px" }}>
          चंद्रपूर जिल्ह्यातील एक प्रगतशील पंचायत समिती
        </p>
      </div>

      {/* INTRO */}
      <section style={{ padding: "20px", textAlign: "center" }}>
        <h2>आमच्याबद्दल</h2>
        <p style={{ maxWidth: "800px", margin: "auto", lineHeight: "1.6" }}>
          पंचायत समिती बल्लारपूर ही नागरिकांच्या सर्वांगीण विकासासाठी
          सातत्याने विविध शासकीय योजना, सुविधा आणि प्रकल्पांची अंमलबजावणी करते.
          पारदर्शक प्रशासन, स्वच्छता, शिक्षण, आरोग्य आणि ग्रामीण विकास हे आमचे प्रमुख उद्दिष्ट.
        </p>
      </section>

      {/* POPULATION TABLE */}
      <section style={{ padding: "20px", textAlign: "center" }}>
        <h2 style={{ marginBottom: "20px" }}>बल्लारपूर तालुका लोकसंख्या माहिती</h2>

        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={thStyle}>माहिती</th>
              <th style={thStyle}>2011 लोकसंख्या</th>
            </tr>
          </thead>

          <tbody>
            <tr style={rowStyle}>
              <td style={tdStyle}>एकूण लोकसंख्या</td>
              <td style={tdStyle}>1,34,540</td>
            </tr>

            <tr>
              <td style={tdStyle}>पुरुष</td>
              <td style={tdStyle}>69,461</td>
            </tr>

            <tr style={rowStyle}>
              <td style={tdStyle}>स्त्रिया</td>
              <td style={tdStyle}>65,079</td>
            </tr>

            <tr>
              <td style={tdStyle}>शहरी लोकसंख्या</td>
              <td style={tdStyle}>1,02,686 (76.3%)</td>
            </tr>

            <tr style={rowStyle}>
              <td style={tdStyle}>ग्रामीण लोकसंख्या</td>
              <td style={tdStyle}>31,854 (23.7%)</td>
            </tr>

            <tr>
              <td style={tdStyle}>बल्लारपूर नगर परिषद लोकसंख्या</td>
              <td style={tdStyle}>89,452</td>
            </tr>
          </tbody>
        </table>

        <h3 style={{ marginTop: "25px", fontWeight: "700" }}>
          🌟 2025 अंदाजित लोकसंख्या
        </h3>

        <p style={{ fontSize: "20px", fontWeight: "600" }}>
          बल्लारपूर नगर परिषद : <span style={{ color: "#6A1B9A" }}>128,000</span>
        </p>
      </section>

      {/* =========================== */}
      {/* 🟣 नवीन सेक्शन –  बल्लारपूर एक खिडकी सेवा */}
      {/* =========================== */}
      {/* TWO COLUMN SERVICE TABLES */}
      <section style={{ padding: "40px 20px", textAlign: "center" }}>
        <h2 style={{ marginBottom: "5px", color: "#1a237e", fontSize: "32px" }}>
          पंचायत समिती  बल्लारपूर उपक्रम
        </h2>
        <h3 style={{ marginBottom: "25px", color: "#c62828", fontSize: "20px" }}>
          लोकाभिमुख प्रशासन उपक्रमांतर्गत एक खिडकी सेवा
        </h3>

        {/* WRAPPER BOX LIKE IMAGE */}
        <div
          style={{
            background: "#eef2f7",
            padding: "30px",
            borderRadius: "18px",
            width: "95%",
            margin: "auto",
            boxShadow: "0 4px 25px rgba(0,0,0,0.15)",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "25px",
              flexWrap: "wrap",
            }}
          >
            {/* TABLE STYLE EXACT LIKE IMAGE */}
            {/** COMMON TABLE STYLE */}
            {[
              {
                title: "left",
                data: [
                  "जन्म- मृत्यू दाखले",
                  "दारिद्र्य रेषेखालील दाखले",
                  "वैयक्तिक सौचालय मागणी",
                  "ए. प्रावि. कार्यक्रमाखालील मागणी",
                  "तक्रार अर्ज / माहितीचा अधिकार",
                  "समाज कल्याण विभागाकडील योजना",
                  "बायोगॅस / सुधारित चुली",
                  "महिला व बालकल्याण विभागांकडील योजना",
                  "पाणीटंचाई / टँकरपूरवठा",
                  "कायदेविषयक सहाय्य / सल्ला",
                  "ट्रायसेम विद्यानिकेतन",
                  "शाळा / शिक्षण विषयक योजना व तक्रारी",
                  "साथीचे रोग",
                  "टी.सी.एल पुरवठा",
                  "दशलक्ष / जवाहर विहिरी मागणी",
                  "कुटीर ज्योत",
                  "हातपंप / विजपंप दुरुस्ती",
                ],
                start: 1,
              },
              {
                title: "right",
                data: [
                  "नळपाणी पुरवठा देखभाल व दुरुस्ती",
                  "खत पुरवठा",
                  "खतवाटप / बियाणे वाटप",
                  "कृषि विषयक योजना",
                  "नैसर्गिक आपत्ती घरबंधणी परवानगी",
                  "निवृत्ती वेतन",
                  "जिल्हा ग्रामीण विकास यंत्रणेकडील योजना",
                  "पशुसंवर्धन विभागाकडील योजना",
                  "इतर वैयक्तिक लाभाच्या योजना",
                  "बांधकाम विषयक योजना",
                  "शिक्षण खात्याच्या योजना",
                  "राजीव गांधी निवारा 2 घरकुल कर्ज योजना",
                  "इंदिरा आवास घरकुल योजना",
                  "बचत गट स्थापन",
                  "मुद्रांक शुल्क",
                  "ग्रामस्थदिन",
                  "तक्रार निवारण दिन",
                  "तालुका विकास दिन",
                  "नैसर्गिक आपत्ती – शेती नुकसान",
                  "ग्रामपंचायती संबंधी माहिती",
                  "प्रशासन विषयक माहिती",
                ],
                start: 20,
              },
            ].map((tbl, index) => (
              <table
                key={index}
                style={{
                  width: "48%",
                  minWidth: "350px",
                  borderCollapse: "collapse",
                  background: "white",
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 3px 10px rgba(0,0,0,0.20)",
                }}
              >
                <thead>
                  <tr>
                    <th
                      style={{
                        background: "#0d47a1",
                        color: "#fff",
                        padding: "12px",
                        fontSize: "18px",
                      }}
                    >
                      अनु. क्रमांक
                    </th>
                    <th
                      style={{
                        background: "#0d47a1",
                        color: "#fff",
                        padding: "12px",
                        fontSize: "18px",
                      }}
                    >
                      कामाचे स्वरूप
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {tbl.data.map((txt, i) => (
                    <tr
                      key={i}
                      style={{
                        background: i % 2 === 0 ? "#e3f2fd" : "white",
                      }}
                    >
                      <td
                        style={{
                          padding: "10px",
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#000",
                        }}
                      >
                        {tbl.start + i}
                      </td>
                      <td
                        style={{
                          padding: "10px",
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#000",
                        }}
                      >
                        {txt}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ))}
          </div>
        </div>
      </section>


      {/* QUICK LINKS */}
      <section style={{ padding: "20px", textAlign: "center" }}>
        <h2>महत्वाचे दुवे</h2>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "20px",
            flexWrap: "wrap",
            marginTop: "20px",
          }}
        >
          <Link className="card" to="/departments">विभाग</Link>
          <Link className="card" to="/schemes">योजना</Link>
          <Link className="card" to="/officers">अधिकारी</Link>
          <Link className="card" to="/ministers">पदाधिकारी</Link>
          <Link className="card" to="/contact">संपर्क</Link>
        </div>
      </section>

      {/* GOOGLE MAP */}
      <section style={{ padding: "20px", textAlign: "center", marginTop: "10px" }}>
        <h2 style={{ marginBottom: "15px" }}>📍 आमचे स्थान</h2>

        <div
          style={{
            width: "90%",
            height: "450px",
            margin: "auto",
            borderRadius: "15px",
            overflow: "hidden",
            boxShadow: "0 6px 25px rgba(0,0,0,0.25)",
            border: "3px solid #4A148C",
          }}
        >
          <iframe
            title="Panchayat Samiti Ballarpur Map"
            width="100%"
            height="100%"
            loading="lazy"
            style={{ border: 0 }}
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3784.1664738809614!2d79.3483367!3d19.8521892!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd2d2ee4f627b11%3A0x748c08436862a5da!2sPanchayat%20Samiti%20Office%20Balharshah!5e0!3m2!1sen!2sin!4v1700000000000"
          ></iframe>
        </div>

        <p style={{ marginTop: "15px", fontSize: "18px", fontWeight: "600", color: "#4A148C" }}>
          🏢 पंचायत समिती कार्यालय, बल्लारपूर — Railway Nagar Ward, Mancherial–Nagpur Road
        </p>
      </section>
    </div>
  );
}
